import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiDashboardGet } from '@/entities/dashboard/modules/api/dashboard';

export const useDashboard = () =>
  useFetch({
    api: apiDashboardGet,
    keywords: queryKeys.dashboard,
    staleTime: 5 * 60 * 1000,
  });
